import KroBackButton from "features/components/buttons/kroBackButton";
import generateShareLink from "common/utils/shareLink";
import KroModal from "features/components/modals/kroModal";
import { useState } from "react";
import KroTextField from "features/components/inputs/kroTextField";
import { SocialMediaHolder } from "features/components/modals/socialMediaHolder";
import { KroInputFieldType } from "features/campaign/domain/enums/kroInputFieldType.enum";
import KroBanner from "features/components/banners/kroBanner";
import { KroButton } from "features/components/buttons/kroButton";
import { useNavigate } from "react-router-dom";
import Routes from "router/routes";

interface KroSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    firstName: string;
    campaignId: string;
}

const KroSuccessModal = ({
    isOpen,
    onClose,
    firstName,
    campaignId
}: KroSuccessModalProps) => {

    const navigate = useNavigate();

    const [showQRCode, setShowQRCode] = useState(false);
    const shareLink = generateShareLink(campaignId);
    const url = window.location.origin + "/" + campaignId;

    const socialMediaList = [
        {
            imgsrc: "/assets/icons/facebook.svg",
            medium: "Facebook",
            shareUrl: `https://www.facebook.com/sharer/sharer.php?url=${shareLink}`,
        },
        {
            imgsrc: "/assets/icons/twitter-x.svg",
            medium: "X (Twitter)",
            shareUrl: `https://twitter.com/intent/tweet?url=${shareLink}`,
        },
        {
            imgsrc: "/assets/icons/whatsapp.svg",
            medium: "Whatsapp",
            shareUrl: `https://api.whatsapp.com/send?text=${shareLink}`,
        },
        {
            imgsrc: "/assets/icons/qr-code-line.svg",
            medium: "QR Code",
            shareUrl: `${url}`,
            onClick: () => setShowQRCode(true),
        },
    ];

    const openInNewTab = (url: string) => {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };
    return (
        <KroModal showCloseButton={false} lottieAnimation={true} closeOnOutsideClick={false} maxWidth={608} maxHeight={659} className="px-0 lg:py-3 py-4" isOpen={isOpen} onClose={onClose}>
            <>
                <div className="flex flex-col gap-4 border-b-[1px] border-b-[#E1E4EA] py-4 px-4 items-center justify-center">
                    <p className="font-inter font-semibold text-neutral-900 lg:text-[24px] text-[20px] leading-[120%] tracking-[-1.5%]">You're amazing {firstName} 🤩 🙏🏾</p>
                    <p className="font-inter text-center font-normal lg:text-[16px] text-[12px] leading-[20px] lg:leading-[24px] tracking-[-1.5%] text-neutral-700">
                        Help this campaign reach more kind people like you by sharing it with your friends, in a group, or via a status update
                    </p>
                </div>
                <div className="lg:mt-6 mt-4 flex  flex-col items-center justify-center">
                    <p className="text-neutral-900 px-4 font-inter font-medium text-[16px] leading-[120%] tracking-[-1.5%]">Tap an icon to share</p>
                    <div className=" rounded-xl">
                        {showQRCode ? (
                            <div className="flex flex-col ">
                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${shareLink}`}
                                    alt="QR Code"
                                />
                                <KroBackButton
                                    classname="mt-4"
                                    onclick={() => setShowQRCode(false)}
                                ></KroBackButton>
                            </div>
                        ) : (
                            <div className="">
                                <div className="mb-[16px] grid grid-cols-4 justify-items-center lg:mt-6 mt-4">
                                    {socialMediaList.map((socialMedium, index) => (
                                        <SocialMediaHolder
                                            onClick={() => {
                                                if (socialMedium.onClick) {
                                                    return socialMedium.onClick();
                                                }
                                                return openInNewTab(socialMedium.shareUrl);
                                            }}
                                            key={index}
                                            imgSrc={socialMedium.imgsrc}
                                            medium={socialMedium.medium}
                                            className="hover:bg-neutral-200"
                                        />
                                    ))}
                                </div>
                                <div className="border-t-[#E5E5E5] border-t-[1px] px-4 lg:pt-6 pt-4 items-center justify-center flex flex-col">
                                    <p className="text-neutral-900 font-inter font-medium lg:text-[16px] text-[14px] leading-[120%] tracking-[-1.5%]">Or use this link</p>
                                    <KroTextField
                                        className="mb-0 lg:mt-3 mt-2"
                                        value={shareLink}
                                        placeHolder={url.replace("https://", "").replace("http://", "")}
                                        label=""
                                        copyText="Copy Link"
                                        type={KroInputFieldType.COPIER}
                                    />
                                </div>
                                <div className="px-4">
                                    <KroBanner variant="info" visible={true} className="lg:mb-8 mb-2 mt-2 rounded-[12px] border border-[#BED2FF]">
                                        <div className="flex flex-row">
                                            <img
                                                src="/assets/icons/info-blue.svg"
                                                alt="information icon blue"
                                                className="mr-2 h-[20px] w-[20px]"
                                            />
                                            <p className="font-inter font-normal text-[12px] leading-[20px] tracking-[-1.5%] text-[#421600]">Paste this link in a group chat or status update — even one share can make a big difference.</p>
                                        </div>
                                    </KroBanner>
                                    <KroButton
                                        className="w-full mt-4 h-[60px]"
                                        title="I've shared"
                                        onclick={() => {
                                            navigate(Routes.CAMPAIGN_DETAILS(campaignId ?? ""), { replace: true });
                                        }}
                                    />
                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </>
        </KroModal>
    );
};

export default KroSuccessModal;